<button
  type="button"
  class="tenant-picker-item btn btn-light w-100 text-start d-flex align-items-start gap-2"
  [class.tenant-picker-item--current]="isCurrentTenant"
  [disabled]="isCurrentTenant"
  (click)="onSelect()">
  <tenant-status-icon [selected]="isCurrentTenant"></tenant-status-icon>
  <tenant-item
    [displayName]="tenant?.displayName() || tenant?.tenantSlug() || tenant?.tenantId()"
    [tenantSlug]="tenant?.tenantSlug() || tenant?.tenantId()">
  </tenant-item>
</button>
